import { Select } from 'antd';
import { memo } from 'react';

const FieldWrapper = ({
  label,
  required,
  error,
  touched,
  helperText,
  className = '',
  children,
}) => (
  <div className={`mb-4 ${className}`}>
    {label && (
      <label className="mb-1 block desktop:text-sm text-xs font-medium text-gray-700 dark:text-gray-300">
        {label}
        {required && <span className="ml-1 text-error">*</span>}
      </label>
    )}
    {children}
    {touched && error && <p className="mt-1 desktop:text-sm text-xs text-error">{error}</p>}
    {!error && helperText && (
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{helperText}</p>
    )}
  </div>
);

const Dropdown = memo(
  ({
    label,
    required,
    error,
    touched,
    helperText,
    options = [],
    className = '',
    fieldClassName = 'w-full',
    placeholder = 'Select an option',
    allowClear = true,
    ...props
  }) => (
    <FieldWrapper
      label={label}
      required={required}
      error={error}
      touched={touched}
      helperText={helperText}
      className={className}
    >
      <Select
        options={options}
        placeholder={placeholder}
        allowClear={allowClear}
        className={fieldClassName}
        status={touched && error ? 'error' : ''}
        {...props}
      />
    </FieldWrapper>
  ),
);

Dropdown.displayName = 'Dropdown';

export default Dropdown;
